export const DEVICE_CHANGED = 'env/DEVICE_CHANGED';
export const LOCALE_CHANGED = 'env/LOCALE_CHANGED';
export const VIEWPORT_CHANGED = 'env/VIEWPORT_CHANGED';

export const CLIENT_TOKEN_SET = 'env/CLIENT_TOKEN_SET';
export const FETCH_APP_INIT_SUCCESS = 'env/FETCH_APP_INIT_SUCCESS';
export const FETCH_APP_INIT_FAILURE = 'env/FETCH_APP_INIT_FAILURE';
export const TOGGLE_REFRESH: 'env/TOGGLE_REFRESH' = 'env/TOGGLE_REFRESH';
